<div class="dialog-header">
    <span>Oil Refinery {{ isPlanned ? 'Planned Outage' : 'Alert' }} Info</span>
    <fa-icon icon="times" style="color: #c9c9c9" (click)="dialogRef.close()"></fa-icon>
</div>

<div #content class="dialog-content">
    <ng-container *ngIf="!isPlanned" [ngTemplateOutlet]="alert"></ng-container>
    <ng-container *ngIf="isPlanned" [ngTemplateOutlet]="planned"></ng-container>
</div>

<ng-template #alert>
    <div class="box">
        <span class="tiny-header">Description</span>
        <span class="val">{{ alertData.description }}</span>
    </div>

    <div class="box">
        <span class="tiny-header">Facility</span>
        <span class="val">{{ alertData.facility_name || alertData.facility_id }}</span>
    </div>

    <div class="box">
        <span class="tiny-header">Product Class</span>
        <span class="val">{{ alertData.product_class }}</span>
    </div>

    <div class="box">
        <span class="tiny-header">Date</span>
        <span class="val">{{ alertData.distributed_datetime | momentDate }}</span>
    </div>
</ng-template>

<ng-template #planned>
    <div class="box">
        <span class="tiny-header">Comments</span>
        <span class="val">{{ alertData.comments }}</span>
    </div>

    <div class="box">
        <span class="tiny-header">Outage Type</span>
        <span class="val">{{ alertData.outage_type }}</span>
    </div>

    <div class="box">
        <span class="tiny-header">Status</span>
        <span class="val">{{ alertData.status }}</span>
    </div>

    <div class="box">
        <span class="tiny-header">Expected Dates</span>
        <span class="val"
            >{{ alertData.expected_start_date | momentDate : 'MM/DD/YYYY' }} -
            {{ alertData.expected_end_date | momentDate : 'MM/DD/YYYY' }}</span
        >
    </div>

    <div class="box">
        <span class="tiny-header">Observed Dates</span>
        <span class="val"
            >{{ alertData.observed_start_date | momentDate : 'MM/DD/YYYY' }} -
            {{ alertData.observed_end_date | momentDate : 'MM/DD/YYYY' }}</span
        >
    </div>
</ng-template>

<div class="dialog-actions">
    <button mat-stroked-button (click)="dialogRef.close()">Close</button>
</div>
